module.exports = __webpack_public_path__ + "img/cu07.ca1653b8.jpg";